/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Phase2_FetchInputs */

const en_directory_submit_enrich_phase2_fetch = /** @type {(inputs: Directory_Submit_Enrich_Phase2_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading your website`)
};

const zh_directory_submit_enrich_phase2_fetch = /** @type {(inputs: Directory_Submit_Enrich_Phase2_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`读取你的网站`)
};

/**
* | output |
* | --- |
* | "Reading your website" |
*
* @param {Directory_Submit_Enrich_Phase2_FetchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_phase2_fetch = /** @type {((inputs?: Directory_Submit_Enrich_Phase2_FetchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Phase2_FetchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_phase2_fetch(inputs)
	return zh_directory_submit_enrich_phase2_fetch(inputs)
});
export { directory_submit_enrich_phase2_fetch as "directory.submit.enrich.phase2.fetch" }